import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { fetchCompanyProfiles } from "../../../../../store/slices/companyProfileSlice";
import { fetchLeads } from "../../../../../store/slices/leadsSlice";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import {
  createQuotation,
  downloadQuotationFile,
  // editGenerateQuotation,
  fetchAllQuotations,
  sendQuotationToClient,
} from "../../../../../store/slices/generateQuotationSlice";
import { fetchAllQuotationTemplates } from "../../../../../store/slices/QuotationTemplateSlice";
import FilesViewer from "../../../../lead/FilesViewer";
import FileViewer from "../CreateQuotation/FileViewer";
import { getFilesByLead } from "../../../../../store/slices/FileDataSlice";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import configApi from "../../../../../config/api";
import {
  attachCrmHardwareTableEditorHandlers,
  buildCrmHardwareDetailsSectionHtml,
} from "../../../../../utils/crmQuotationHardwareEditor";
// Try this import instead
import JoditEditor from "jodit-react";
// Remove ReactQuill CSS since we're using Jodit
// import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
const Quotation = ({
  tasks,
  items,
  filteredQuotation,
  selectedGroup,
  selectedProject,
  setShowQuoteModal,
  selectedlead,
  selectedServiceTypes,
  financeDataProject,
  tableServiceTotals: tableServiceTotalsProp,
  canCreateQuotation = true,
  canDownloadQuotation = true,
  canSendQuotation = true,
}) => {
  console.log("fselectedlead", selectedlead);
  console.log("fselectedlead financeDataProject", financeDataProject);
  console.log("filteredQuotation filteredQuotation items q", items);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  const [isHistoryOpen, setisHistoryOpen] = useState(false);
  const [, setAssignedGroup] = useState("All");
  const [template, settemplate] = useState([]);
  const { templates } = useSelector((state) => state.quotationTemplates);
  const [content, setContent] = useState("");
  const [editcontent, seteditContent] = useState(""); // Changed from value to content
  console.log("sendQuotationToClient templates", templates)
  const { profiles } = useSelector((state) => state.companyProfile);
  const { leads } = useSelector((state) => state.leads);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedTemplate, setselectedTemplate] = useState("");
  const [replacedData, setReplacedData] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [Templateid, setTemplateid] = useState(null);
  // const [autosaveid, setautosaveid] = useState(null);
  const [leadid, setleadid] = useState(null);
  const [fileid, setfileid] = useState(null);
  const [sendid, setsendid] = useState(null);
  const [downloadid, setdownloadid] = useState(null);
  const { quotations } = useSelector((state) => state.generateQuotation);
  const [, sethistoryid] = useState("");
  const [files, setFiles] = useState();
  const [fileName, sefileName] = useState([]);
  const [showfile, seshowfile] = useState([]);
  const [quotation, sequotations] = useState([]);
  const debounceTimeoutRef = useRef(null);
  const { employees } = useSelector((state) => state.employees);
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const [, sethardwareparts] = useState([]);
  const [, setquotedprojects] = useState([]);
  const [IsEdit, setIsEdit] = useState(false);
  const [setMailQuotation, setsetMailQuotation] = useState(null);
  const [showEditPreview, setShowEditPreview] = useState(false);
  const [editedTemplate, setEditedTemplate] = useState("");
  const [showVersionHistoryHint, setShowVersionHistoryHint] = useState(false);
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();

  /** Map "how many digits are to the left of the caret" → index in formatted string (USA / Indian). */
  const caretIndexAfterDigitCount = (formatted, digitCount) => {
    if (digitCount <= 0) return 0;
    let dc = 0;
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        dc += 1;
        if (dc === digitCount) return i + 1;
      }
    }
    return formatted.length;
  };

  /**
   * Formats CRM Finance Summary price inputs (USA vs Indian grouping) and keeps value attribute in sync for Generate.
   * Preserves caret on `input` so users can edit again (assigning value resets selection otherwise; Jodit also fights nested inputs).
   */
  const formatServicePriceElement = useCallback(
    (el, preserveCaret = true) => {
      if (!el || el.tagName !== "INPUT") return;
      const isUSA = String(currency || "").trim() === "$";
      const oldVal = String(el.value ?? "");
      let digitsBeforeStart = 0;
      let digitsBeforeEnd = 0;
      if (
        preserveCaret &&
        typeof el.selectionStart === "number" &&
        typeof el.selectionEnd === "number"
      ) {
        digitsBeforeStart = oldVal
          .slice(0, el.selectionStart)
          .replace(/[^0-9]/g, "").length;
        digitsBeforeEnd = oldVal
          .slice(0, el.selectionEnd)
          .replace(/[^0-9]/g, "").length;
      }
      const v = oldVal.replace(/[^0-9]/g, "");
      if (!v) {
        el.value = "";
        try {
          el.setAttribute("value", "");
        } catch (_) {
          /* ignore */
        }
        return;
      }
      let out;
      if (isUSA) {
        out = v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        if (v.length <= 3) {
          out = v;
        } else {
          const last3 = v.slice(-3);
          let rest = v.slice(0, -3);
          const parts = [];
          while (rest.length > 2) {
            parts.unshift(rest.slice(-2));
            rest = rest.slice(0, -2);
          }
          if (rest) parts.unshift(rest);
          out = parts.join(",") + "," + last3;
        }
      }
      el.value = out;
      try {
        el.setAttribute("value", out);
      } catch (_) {
        /* ignore */
      }
      if (preserveCaret && typeof el.setSelectionRange === "function") {
        const start = caretIndexAfterDigitCount(out, digitsBeforeStart);
        const end = caretIndexAfterDigitCount(out, digitsBeforeEnd);
        requestAnimationFrame(() => {
          try {
            el.setSelectionRange(start, end);
          } catch (_) {
            /* ignore */
          }
        });
      }
    },
    [currency]
  );

  /**
   * Jodit onChange HTML often serializes Finance Summary inputs without commas in value="…".
   * Re-applying that string overwrites the live formatted field. Normalize before setContent so commas persist on every edit.
   */
  const normalizeFinanceSummaryPriceInputsInHtml = useCallback(
    (html) => {
      if (!html || typeof html !== "string" || !html.includes("servicePrice_")) {
        return html;
      }
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          `<div data-quotation-finance-wrap="1">${html}</div>`,
          "text/html"
        );
        const wrap = doc.querySelector("[data-quotation-finance-wrap]");
        if (!wrap) return html;
        wrap.querySelectorAll('input[name^="servicePrice_"]').forEach((inp) => {
          formatServicePriceElement(inp, false);
        });
        return wrap.innerHTML;
      } catch {
        return html;
      }
    },
    [formatServicePriceElement]
  );

  const isFinanceOrHardwareEditableInputName = useCallback((name) => {
    const n = String(name || "");
    return (
      n.startsWith("servicePrice_") ||
      n.startsWith("hardwarePartName_") ||
      n.startsWith("hardwarePartQty_")
    );
  }, []);

  // Processed template HTML with <!-- SUMMARY_TABLES --> marker so we can inject table when it loads/updates
  const [processedTemplateHtml, setProcessedTemplateHtml] = useState("");
  const [summaryTableHtml, setSummaryTableHtml] = useState("");
  const [hasManualEditorChanges, setHasManualEditorChanges] = useState(false);
  const resolvedCompanyLogoUrl = useMemo(() => {
    const profile = profiles?.[0];
    const raw = String(
      // Sidebar footer uses `logoPath`; prefer it here too for CRM consistency.
      profile?.logoPath || profile?.companylogo || profile?.companyLogo || ""
    ).trim();
    if (!raw) return "";

    let absoluteUrl = raw;
    const isAbsolute =
      /^https?:\/\//i.test(raw) || /^data:/i.test(raw) || /^blob:/i.test(raw);
    if (!isAbsolute) {
      const backendUrl = String(configApi?.backendUrl || "").trim();
      const backendOrigin = backendUrl.replace(/\/api\/?$/i, "").replace(/\/$/, "");
      const normalizedPath = raw.replace(/^\.?\//, "");
      absoluteUrl = backendOrigin
        ? `${backendOrigin}/${normalizedPath}`
        : normalizedPath;
    }

    const stamp = profile?.updatedAt || profile?._id || "";
    if (!stamp) return absoluteUrl;
    return absoluteUrl.includes("?")
      ? `${absoluteUrl}&v=${encodeURIComponent(String(stamp))}`
      : `${absoluteUrl}?v=${encodeURIComponent(String(stamp))}`;
  }, [profiles]);

  useEffect(() => {
    if (!filteredQuotation || !employees?.length || !items?.length) return;

    const matchedItems = [];

    Object.entries(filteredQuotation).forEach(([projectName, services]) => {
      Object.entries(services).forEach(([serviceType, serviceArray]) => {
        serviceArray.forEach((service) => {
          const projectId = service.ProjectID;

          service.Assignedperson?.forEach((person) => {
            const matchedEmployee = employees.find(
              (emp) => emp.EmpEmail === person.email
            );

            if (matchedEmployee) {
              const personItems = items.filter(
                (item) =>
                  item.projectid === projectId &&
                  item.taskownerid === matchedEmployee._id
              );
              matchedItems.push(...personItems);
            }
          });
        });
      });
    });
    sethardwareparts(matchedItems);
  }, [filteredQuotation, employees, items]);

  useEffect(() => {
    console.log("fselectedlead", selectedlead);
    console.log("fselectedlead financeDataProject", financeDataProject);

    if (selectedlead && selectedlead.ProjectName && financeDataProject) {
      // Filter financeDataProject to get projects with matching project name
      const matchingProjects = financeDataProject.filter(
        project => project.ProjectName === selectedlead.ProjectName
      );
      setquotedprojects(matchingProjects);
      console.log("Matching projects:", matchingProjects);
      console.log("Number of matching projects:", matchingProjects.length);

    }
  }, [selectedlead, financeDataProject]);
  // Jodit Editor Ref
  const editor = useRef(null);
  const imageUploadInputRef = useRef(null);
  const activeEditorForImageRef = useRef(null);

  const handlePickImageFromDevice = useCallback((joditInstance) => {
    activeEditorForImageRef.current = joditInstance || editor.current?.editor || editor.current || null;
    if (imageUploadInputRef.current) {
      imageUploadInputRef.current.value = "";
      imageUploadInputRef.current.click();
    }
  }, []);

  const handleImageFileSelected = useCallback((event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      enqueueSnackbar("Please select a valid image file", { variant: "warning" });
      return;
    }
    const maxBytes = 8 * 1024 * 1024;
    if (file.size > maxBytes) {
      enqueueSnackbar("Image file is too large (max 8 MB). Choose a smaller file.", {
        variant: "warning",
      });
      return;
    }
    // Resize + compress before inserting so generated quotation payload stays small.
    const imageObjectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        const targetW = 260;
        const targetH = 180;
        canvas.width = targetW;
        canvas.height = targetH;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          URL.revokeObjectURL(imageObjectUrl);
          return;
        }

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, targetW, targetH);

        const ratio = Math.min(targetW / img.width, targetH / img.height);
        const drawW = img.width * ratio;
        const drawH = img.height * ratio;
        const offsetX = (targetW - drawW) / 2;
        const offsetY = (targetH - drawH) / 2;
        ctx.drawImage(img, offsetX, offsetY, drawW, drawH);

        const compressedSrc = canvas.toDataURL("image/jpeg", 0.82);

        const joditInstance =
          activeEditorForImageRef.current ||
          editor.current?.editor ||
          editor.current ||
          null;
        if (!joditInstance) {
          URL.revokeObjectURL(imageObjectUrl);
          return;
        }

        const imageHtml = `<img src="${compressedSrc.replace(/"/g, "&quot;")}" alt="Uploaded Image" class="psk-uploaded-inline-image" style="display: block; margin: 12px auto; width: 260px; height: 180px; object-fit: contain; float: none;" />`;
        if (joditInstance?.s?.insertHTML) {
          joditInstance.s.insertHTML(imageHtml);
        } else if (joditInstance?.selection?.insertHTML) {
          joditInstance.selection.insertHTML(imageHtml);
        }
      } finally {
        URL.revokeObjectURL(imageObjectUrl);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(imageObjectUrl);
      enqueueSnackbar("Unable to process selected image", { variant: "error" });
    };
    img.src = imageObjectUrl;
  }, [enqueueSnackbar]);

  // Jodit configuration
  const config = useMemo(
    () => ({
      saveSelectionOnBlur: true,
      readonly: false,
      height: 400,
      toolbarAdaptive: false,
      removeButtons: ["source", "about"],
      events: {
        afterInit(jodit) {
          const root = jodit.editor;
          if (!root) return;

          // Let nested finance/hardware inputs keep focus on repeat clicks
          // (Jodit/contenteditable otherwise steals mousedown).
          const stopJoditFromStealingInnerInputs = (e) => {
            const t = e.target;
            if (!t || typeof t.getAttribute !== "function") return;
            const name = t.getAttribute("name") || "";
            if (isFinanceOrHardwareEditableInputName(name)) {
              e.stopPropagation();
            }
          };
          root.addEventListener("mousedown", stopJoditFromStealingInnerInputs, true);
          root.addEventListener("click", stopJoditFromStealingInnerInputs, true);

          // Backspace/Delete bubble from the nested <input> to `editor`, where Jodit proxies keydown → hotkeys →
          // execCommand(backspaceButton) and steals focus to the toolbar ("T"). Jodit's listener is registered
          // before we can prepend on the same node, so stopPropagation on each price input (must not use capture,
          // or the input would not receive the key).
          const attachEditableInputKeyStop = (inp) => {
            if (!inp || inp.tagName !== "INPUT") return;
            const name = inp.getAttribute("name") || "";
            if (!isFinanceOrHardwareEditableInputName(name)) return;
            if (inp.dataset.pskFinancePriceKeyStop) return;
            inp.dataset.pskFinancePriceKeyStop = "1";
            inp.addEventListener(
              "keydown",
              (e) => {
                if (e.key !== "Backspace" && e.key !== "Delete") return;
                e.stopPropagation();
              },
              false
            );
          };
          root
            .querySelectorAll(
              'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
            )
            .forEach(attachEditableInputKeyStop);
          const priceInputObserver = new MutationObserver((mutations) => {
            mutations.forEach((m) => {
              m.addedNodes.forEach((node) => {
                if (!node || node.nodeType !== 1) return;
                const el = /** @type {Element} */ (node);
                if (
                  el.matches?.(
                    'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
                  )
                ) {
                  attachEditableInputKeyStop(/** @type {HTMLInputElement} */ (el));
                }
                el
                  .querySelectorAll?.(
                    'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
                  )
                  .forEach((n) => {
                    attachEditableInputKeyStop(/** @type {HTMLInputElement} */ (n));
                  });
              });
            });
          });
          priceInputObserver.observe(root, { childList: true, subtree: true });
          jodit.e.one("beforeDestruct", () => {
            priceInputObserver.disconnect();
          });

          attachCrmHardwareTableEditorHandlers({
            jodit,
            root,
            setContent,
            isFinanceOrHardwareEditableInputName,
          });

          const onPriceFieldEvent = (e) => {
            const t = e.target;
            if (!t || typeof t.getAttribute !== "function") return;
            const name = t.getAttribute("name") || "";
            const isServicePrice = name.startsWith("servicePrice_");
            const isHardwarePartName = name.startsWith("hardwarePartName_");
            const isHardwarePartQty = name.startsWith("hardwarePartQty_");
            if (!isServicePrice && !isHardwarePartName && !isHardwarePartQty) return;
            if (e.type === "input") {
              if (isServicePrice) {
                formatServicePriceElement(t, true);
              } else if (isHardwarePartName || isHardwarePartQty) {
                if (isHardwarePartQty) {
                  t.value = String(t.value || "").replace(/[^0-9]/g, "");
                }
                try {
                  t.setAttribute("value", t.value || "");
                } catch (_) {
                  /* ignore */
                }
              }
              setHasManualEditorChanges(true);
            } else if (e.type === "focusout") {
              if (isServicePrice) {
                formatServicePriceElement(t, false);
              }
            }
          };
          jodit.e.on(root, "input", onPriceFieldEvent);
          jodit.e.on(root, "focusout", onPriceFieldEvent);
        },
      },
      buttons: [
        "bold",
        "italic",
        "underline",
        "strike",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "fontsize",
        "brush",
        "|",
        {
          name: "uploadImageInline",
          icon: "image",
          tooltip: "Upload image",
          exec: (joditInstance) => {
            handlePickImageFromDevice(joditInstance);
          },
        },
        "|",
        "align",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "|",
        "fullsize",
      ],
      table: {
        allowCellSelection: true,
        allowResize: true,
      },
      pasteHTMLAction: "insert_clear_html", // Important for preserving HTML
    }),
    [
      handlePickImageFromDevice,
      formatServicePriceElement,
      isFinanceOrHardwareEditableInputName,
    ]
  );

  // Handle editor change with proper debounce
  const handleEditorChangeWithDebounce = useCallback(
    (newContent) => {
      setHasManualEditorChanges(true);

      const editorInstance = editor.current?.editor || editor.current;
      const activeElement =
        editorInstance?.ownerDocument?.activeElement ||
        editor.current?.ownerDocument?.activeElement ||
        document?.activeElement ||
        null;
      const activeName = activeElement?.getAttribute
        ? activeElement.getAttribute("name") || ""
        : "";

      // While typing in nested Finance Summary / Hardware inputs, avoid forcing jodit.value on every keypress.
      // That controlled re-sync interrupts multi-digit typing (appears as only one character accepted).
      if (isFinanceOrHardwareEditableInputName(activeName)) {
        return;
      }

      setContent(normalizeFinanceSummaryPriceInputsInHtml(newContent));

      // Clear any existing timeout
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    },
    [normalizeFinanceSummaryPriceInputsInHtml, isFinanceOrHardwareEditableInputName]
  );



  // Load latest auto-save - UPDATE THIS FOR JODIT
  useEffect(() => {
    if (quotations && quotations.length > 0) {
      const filteredQuotations = quotations.filter((q) => q.leadid === leadid);

      // 1. Filter only AutoSave quotations
      const autoSaves = filteredQuotations.filter((q) => q.type === "AutoSave");

      // 2. Sort them by createdAt (latest first)
      const sorted = autoSaves.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      // 3. Get the latest AutoSave
      const latestAutoSave = sorted[0];
      if (latestAutoSave?.templatedata) {
        setContent(latestAutoSave.templatedata); // Use setContent instead of setValue
      }
      // setautosaveid(latestAutoSave?._id);
      // Do not clear currently selected template id when autosave has no templateid.
      if (latestAutoSave?.templateid) {
        setTemplateid(latestAutoSave.templateid);
      }
    }
  }, [quotations, leadid]);

  // Fetch other expenses
  useEffect(() => {
    if (otherExpenses && otherExpenses.length > 0) {
      const perdiemExpense = otherExpenses.find(
        (expense) =>
          expense.description && expense.description.toLowerCase() === "perdiem"
      );

      const averageCostExpense = otherExpenses.find(
        (expense) =>
          expense.description &&
          expense.description.toLowerCase() === "average cost"
      );

      setperdiem(perdiemExpense ? perdiemExpense.cost || 0 : 0);
      setaveragecost(averageCostExpense ? averageCostExpense.cost || 0 : 0);
    } else {
      setperdiem(0);
      setaveragecost(0);
    }
  }, [otherExpenses]);

  // Fetch files
  const fetchFiles = useCallback(async () => {
    if (!fileid) {
      return;
    }
    try {
      const files = await dispatch(getFilesByLead(fileid)).unwrap();
      // Filter only PDF files (case-insensitive)
      const pdfFiles = files.filter((file) =>
        file.filename?.toLowerCase().endsWith(".pdf")
      );

      // Set only PDF files
      seshowfile(pdfFiles);

      // Extract PDF filenames
      const fileNames = pdfFiles.map((file) => file.filename);
      sefileName(fileNames);
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  }, [dispatch, fileid]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  // Filter quotations by lead.quotationId (or leadid fallback) so version history shows only this project's quotations
  useEffect(() => {
    if (!quotations || quotations.length === 0) {
      sequotations([]);
      return;
    }
    const matchId = selectedLead?.quotationId ?? selectedlead?.quotationId ?? selectedlead?.id ?? selectedlead?._id ?? leadid;
    if (matchId == null && leadid == null) {
      sequotations([]);
      return;
    }
    const rowId = selectedlead?.id ?? selectedlead?._id;
    const filteredQuotations = quotations.filter((q) => {
      const qKey = q.quotationId ?? q.quotationNumber ?? q.leadid;
      const matchById = matchId != null && String(qKey) === String(matchId);
      const matchByLeadId = leadid != null && String(q.leadid) === String(leadid);
      const matchByRowId = rowId != null && String(q.leadid) === String(rowId);
      return matchById || matchByLeadId || matchByRowId;
    });
    sequotations(filteredQuotations);
  }, [quotations, leadid, selectedLead?.quotationId, selectedlead?.quotationId, selectedlead?.id, selectedlead?._id]);

  // Set lead by quotationId when available so version history is scoped to this project, not project name (avoids duplicates across projects)
  useEffect(() => {
    const quotationId = selectedlead?.quotationId ?? selectedProject?.quotationId;
    let matchedLead = null;
    if (quotationId != null && String(quotationId).trim() !== "" && leads?.length > 0) {
      matchedLead = leads.find((lead) => String(lead.quotationId || "").trim() === String(quotationId).trim());
    }
    if (!matchedLead && leads?.length > 0 && selectedProject) {
      const filteredLeads = leads.filter((lead) =>
        lead.ProjectName?.toLowerCase().includes(String(selectedProject).toLowerCase())
      );
      matchedLead = filteredLeads[0] ?? null;
    }
    if (matchedLead) {
      setfileid(matchedLead._id);
      setleadid(matchedLead.id);
      sethistoryid(matchedLead.id);
      setSelectedLead(matchedLead);
    } else if (selectedlead && (selectedlead.id != null || selectedlead._id != null)) {
      // Fallback: use row id so version history can match quotations by q.leadid (ERP/CRM when lead not in leads list yet)
      const rowLeadId = selectedlead.id ?? selectedlead._id;
      setleadid(rowLeadId);
    }
  }, [leads, selectedProject, selectedlead]);

  // Fetch initial data
  useEffect(() => {
    dispatch(fetchAllQuotations());
    dispatch(fetchAllQuotationTemplates());
    dispatch(fetchCompanyProfiles());
    dispatch(fetchLeads());
    dispatch(fetchAllProjects());
    dispatch(fetchOtherExpenses());
  }, [dispatch]);

  // Set templates - filter by selectedGroup if provided
  useEffect(() => {
    if (!templates || templates.length === 0) {
      settemplate([]);
      return;
    }

    // Filter templates by selectedGroup (sales/presales)
    // If selectedGroup is provided, filter templates that match the group
    // Otherwise, show all templates
    let filteredTemplates = templates;
    
    if (selectedGroup && selectedGroup !== "All") {
      // Filter templates that have the selectedGroup or no group specified (show all)
      // Templates use 'newGroupName' field to store the group
      filteredTemplates = templates.filter(
        (temp) =>
          !temp.newGroupName || // Template with no group assigned (show for all)
          temp.newGroupName === selectedGroup || // Template matches selected group
          temp.newGroupName?.toLowerCase() === selectedGroup.toLowerCase() // Case-insensitive match
      );
    }

    settemplate(filteredTemplates);
  }, [templates, selectedGroup]);

  // Click outside handlers
  const groupdownRef = useRef(null);
  const handleClickOutsidegroup = (e) => {
    if (groupdownRef.current && !groupdownRef.current.contains(e.target)) {
      setIsTemplateOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidegroup);
    return () => {
      document.removeEventListener("click", handleClickOutsidegroup);
    };
  }, []);

  const versionRef = useRef(null);
  const handleClickOutsideversion = useCallback(
    (e) => {
      if (versionRef.current && !versionRef.current.contains(e.target)) {
        setisHistoryOpen(false);
      }
    },
    [versionRef]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideversion);
    return () => {
      document.removeEventListener("click", handleClickOutsideversion);
    };
  }, [handleClickOutsideversion]);

  // Merge processed template with current summary table so table shows when template loads and stays in sync.
  // Wrap injected summary in comments so at Generate we can replace this block with latest summaryTableHtml (including Required Hardware).
  const buildFinalHtmlFromProcessed = useCallback(
    (processedHtml) => {
      if (!processedHtml) return "";
      let finalHtml = processedHtml;
      if (resolvedCompanyLogoUrl) {
        const logoRegex = /(<img[^>]*alt="Company Logo"[^>]*src=")[^"]*(")/g;
        finalHtml = finalHtml.replace(
          logoRegex,
          `$1${String(resolvedCompanyLogoUrl).replace(/"/g, "&quot;")}$2`
        );
      }
      if (finalHtml.includes("<!-- SUMMARY_TABLES -->") && summaryTableHtml) {
        const wrapped = `<!-- SUMMARY_TABLES_BEGIN -->${summaryTableHtml}<!-- SUMMARY_TABLES_END -->`;
        finalHtml = finalHtml.replace(/<!-- SUMMARY_TABLES -->/g, wrapped);
      }
      return finalHtml;
    },
    [summaryTableHtml, resolvedCompanyLogoUrl]
  );

  // When template is loaded and summary table HTML is ready/updated, show table in editor (before Generate)
  useEffect(() => {
    if (!processedTemplateHtml) return;
    if (hasManualEditorChanges) return;
    const finalHtml = buildFinalHtmlFromProcessed(processedTemplateHtml);
    setContent(finalHtml);
  }, [
    processedTemplateHtml,
    summaryTableHtml,
    buildFinalHtmlFromProcessed,
    hasManualEditorChanges,
  ]);

  // Ensure summary block is replaced when content is set and summaryTableHtml is available (use same wrapper as buildFinalHtmlFromProcessed)
  useEffect(() => {
    if (content && summaryTableHtml && content.includes("<!-- SUMMARY_TABLES -->")) {
      const wrapped = `<!-- SUMMARY_TABLES_BEGIN -->${summaryTableHtml}<!-- SUMMARY_TABLES_END -->`;
      const updatedContent = content.replace(/<!-- SUMMARY_TABLES -->/g, wrapped);
      if (updatedContent !== content) {
        setContent(updatedContent);
      }
    }
  }, [content, summaryTableHtml, tableServiceTotalsProp]);

  // Replace placeholders in template - UPDATE FOR JODIT
  const replacePlaceholders = (html, lead, profile) => {
    if (!lead) return { processedHtml: html, replacedData: {} };

    const currentDate = new Date().toLocaleDateString();
    const subscriptionPackage = String(profile?.subscriptionpackage || '').trim().toUpperCase();
    const isCRMOrERP = ['CRM', 'ERP'].includes(subscriptionPackage);

    const replacedData = {
      "Project Name": lead.ProjectName || "",
      "Client Name": lead.ClientName || "",
      "Current Date": currentDate,
      "Client Contact Name": lead.ClientContactName || "",
      "Client Contact Email": lead.ClientEmail || "",
      "Company Profile Name": profile?.companyname || "",
      "Company Profile Logo": profile?.companylogo || "",
      "Company Profile Email": profile?.companyemail || "",
      "Company Profile Address": profile?.companyaddress || "",
      "File Names": fileName || "",
      templateId: Templateid,
    };

    if (isCRMOrERP) {
      replacedData["Structural Monitoring Proposal"] =
        "<div style='margin-top:16px;'>" +
        "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Structural Monitoring Proposal for Bridge Infrastructure</p>" +
        "<p style='margin:0 0 14px 0;'>To implement a reliable and scalable structural monitoring solution that provides continuous monitoring through high-precision accelerometers and visual inspection using intelligent camera systems.</p>" +
        "<p style='margin:0 0 10px 0; font-weight:700;'>1. Solution Overview</p>" +
        "<p style='margin:0 0 12px 0;'>Our STRUCTURAL MONITORING system integrates sensor-based vibration monitoring with visual inspection tools to provide comprehensive insights into structural performance. The system includes:</p>" +
        "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Accelerometer Modules:</strong> For real-time measurement of vibrations, tilt, and dynamic structural responses.</li>" +
        "<li style='margin-bottom:6px;'><strong>Camera Modules:</strong> For periodic or event-triggered visual capture of the structure, enabling visual correlation with sensor data.</li>" +
        "<li><strong>Centralized Monitoring Interface:</strong> Displays synchronized data, alerts, and reports to the end-user.</li>" +
        "</ul>" +
        "<p style='margin:0 0 10px 0; font-weight:700;'>2. Key Features</p>" +
        "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Time-Synchronized Data Acquisition:</strong> Sensor and camera data aligned to a timeframe.</li>" +
        "<li style='margin-bottom:6px;'><strong>Remote Monitoring Dashboard:</strong> Real-time access to data, event logs, and visual content.</li>" +
        "<li><strong>Threshold Alerts:</strong> Notifications triggered by abnormal vibration or tilt events.</li>" +
        "</ul>" +
        "</div>";

      replacedData["Project Background"] =
        "<div style='margin-top:20px;'>" +
        "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Project Background</p>" +
        "<p style='margin:0 0 12px 0;'>Webber has requested structural monitoring service for their <strong>Mid Toll Bridge, Destin Bridge and Brookes bridge</strong> located at Destin, Florida.</p>" +
        "<p style='margin:0 0 12px 0;'>To address this, <strong>Indus Informatics</strong> will implement a structural monitoring solution designed to provide real-time notifications of any structural response events using a combination of precision accelerometer and tilt sensor technologies. In the event of significant structural activity or displacement, <strong>Indus Informatics</strong> will issue automated alerts to designated WEBBER personnel via SMS, email and voice call.</p>" +
        "<p style='margin:0 0 10px 0;'>The Indus Informatics Structural Monitoring system consists of three core components:</p>" +
        "<ol style='margin:0 0 0 20px; padding-left:16px;'>" +
        "<li style='margin-bottom:6px;'><strong>Sensor Units</strong> &ndash; Capture and monitor dynamic and static structural behaviour (vibration, tilt, and temperature).</li>" +
        "<li style='margin-bottom:6px;'><strong>Communications &amp; Power Hub</strong> &ndash; Controls the system&rsquo;s operations and transmits data.</li>" +
        "<li><strong>Cloud-based Monitoring Platform</strong> &ndash; Receives and processes all incoming data for real-time analysis and alert generation.</li>" +
        "</ol>" +
        "</div>";
    }

    let processedHtml = html;

    // Replace regular placeholders
    Object.entries(replacedData).forEach(([key, value]) => {
      const regex = new RegExp(`{{${key}}}`, "g");
      processedHtml = processedHtml.replace(regex, value);
    });

    // Check for Summary Tables placeholder
    const hasSummaryTables = html.includes("{{Summary Tables}}");

    if (hasSummaryTables) {
      processedHtml = processedHtml.replace(
        /{{Summary Tables}}/g,
        "<!-- SUMMARY_TABLES -->"
      );
    }

    // Clean up any leftover placeholders
    processedHtml = processedHtml.replace(/{{[^}]+}}/g, "");

    // CRM/ERP preview header formatting (make it match the screenshot layout).
    if (isCRMOrERP) {
      let formatted = processedHtml;

      const logoUrl =
        resolvedCompanyLogoUrl ||
        profile?.companylogo ||
        profile?.logoPath ||
        profile?.companyLogo ||
        "";

      const crmHeaderEmail = "info@indusinformatics.com";
      const crmHeaderMarker = "<!-- CRM_QUOTATION_HEADER -->";

      const crmHeaderHtml = `
${crmHeaderMarker}
<div style="width:100%; display:flex; align-items:flex-start; justify-content:space-between; margin-top:6px;">
  <div style="flex:0 0 45%; display:flex; align-items:center;">
    <img src="${String(logoUrl).replace(/"/g, "&quot;")}" alt="Company Logo" style="max-height:60px; object-fit:contain;" />
  </div>
  <div style="flex:0 0 auto; width:1px; background:#000; height:60px; margin:0 14px;"></div>
  <div style="flex:1; text-align:right; font-size:12px; line-height:1.4; padding-top:10px;">
    <div><strong>Email:</strong> ${crmHeaderEmail}</div>
    <div><strong>Address:</strong> 4830, Osage Avenue,<br/>Philadelphia, PA 19143</div>
  </div>
</div>
<div style="margin-top:10px; border-top:2px solid #000;"></div>
`;

      // Move date to top-right: extract date paragraph and re-insert at the beginning.
      const dateParaRegex = /<p>\s*Date:\s*([^<]+)\s*<\/p>/i;
      const dateMatch = formatted.match(dateParaRegex);
      if (dateMatch) {
        const dt = String(dateMatch[1] || '').trim();
        formatted = formatted.replace(dateParaRegex, '');
        formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
      } else {
        // Fallback: if date is not wrapped in <p> tags.
        const dateTextRegex = /Date:\s*([^<\n\r]+)/i;
        const dateTextMatch = formatted.match(dateTextRegex);
        if (dateTextMatch) {
          const dt = String(dateTextMatch[1] || '').trim();
          formatted = formatted.replace(dateTextRegex, '');
          formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
        }
      }

      // Format To section: To, + client name on next line (remove quotes).
      formatted = formatted.replace(
        /<p>\s*To,\s*"([^"]+)"\s*<\/p>/gi,
        (_m, clientName) => `<p>To,</p><p>${String(clientName || '').trim()}</p>`
      );
      // Fallback if To line is not wrapped by <p> tags.
      formatted = formatted.replace(/To,\s*"([^"]+)"\s*/gi, (_m, clientName) => `To,<br/>${String(clientName || '').trim()}`);

      // Format Dear line: Dear + client name, (remove quotes and extra whitespace)
      formatted = formatted.replace(
        /<p>\s*Dear\s*"([^"]+)"\s*,\s*<\/p>/gi,
        (_m, clientName) => `<p>Dear ${String(clientName || '').trim()},</p>`
      );
      formatted = formatted.replace(
        /Dear\s*"([^"]+)"\s*,/gi,
        (_m, clientName) => `Dear ${String(clientName || '').trim()},`
      );

      // Prepend header above date (avoid duplication if template already includes it).
      if (!formatted.includes(crmHeaderMarker) && !formatted.includes(crmHeaderEmail)) {
        processedHtml = crmHeaderHtml + formatted;
      } else {
        processedHtml = formatted;
      }
    }

    return { processedHtml, replacedData };
  };

  // Load template - UPDATE FOR JODIT
  const loadTemplate = async (tplUrl) => {
    try {
      // Validate template URL
      if (!tplUrl) {
        throw new Error("Template URL is missing");
      }

      // Check if URL is valid
      if (typeof tplUrl !== 'string' || tplUrl.trim() === '') {
        throw new Error("Invalid template URL");
      }

      // Ensure selectedLead is available before loading template
      if (!selectedLead) {
        enqueueSnackbar("Please select a project first", { variant: "warning" });
        return;
      }

      const res = await fetch(tplUrl);
      if (!res.ok) {
        throw new Error(`Failed to fetch template: ${res.status} ${res.statusText}`);
      }

      const html = await res.text();
      if (!html || html.trim() === '') {
        throw new Error("Template content is empty");
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      let templateContent = doc.body.innerHTML;

      const profile = profiles.length > 0 ? profiles[0] : null;
      const { processedHtml, replacedData } = replacePlaceholders(
        templateContent,
        selectedLead,
        profile
      );

      setHasManualEditorChanges(false);
      setProcessedTemplateHtml(processedHtml);
      const finalHtml = buildFinalHtmlFromProcessed(processedHtml);
      // buildFinalHtmlFromProcessed already wraps summary in SUMMARY_TABLES_BEGIN/END when replacing marker
      setContent(finalHtml);
      setReplacedData(replacedData);
    } catch (error) {
      console.error("Error loading template:", error);
      const errorMessage = error?.message || "Failed to load template";
      if (enqueueSnackbar) {
        enqueueSnackbar(errorMessage, { variant: "error" });
      }
    }
  };



  const cleanNumericValues = (htmlContent) => {
    return htmlContent;
    // return htmlContent.replace(
    //   />\s*([\d,]+)\s*</g,
    //   (match, numberWithCommas) => {
    //     const cleanNumber = numberWithCommas.replace(/,/g, "");
    //     return `>${cleanNumber}<`;
    //   }
    // );
  };

  const normalizeHardwareDetailsForGeneratedQuote = useCallback((htmlContent) => {
    if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const headingNodes = Array.from(doc.querySelectorAll("p"));

      headingNodes.forEach((pEl) => {
        const title = (pEl.textContent || "").trim().toLowerCase();
        if (title !== "hardware details") return;

        const sectionWrapper = pEl.parentElement;
        if (!sectionWrapper) return;

        const tableEl = sectionWrapper.querySelector("table");
        if (tableEl) {
          const rows = Array.from(tableEl.querySelectorAll("tbody tr"));
          rows.forEach((tr) => {
            const partInput = tr.querySelector('input[name^="hardwarePartName_"]');
            const qtyInput = tr.querySelector('input[name^="hardwarePartQty_"]');
            if (!partInput && !qtyInput) return;

            const partVal = String(partInput?.getAttribute("value") ?? partInput?.value ?? "").trim();
            const qtyVal = String(qtyInput?.getAttribute("value") ?? qtyInput?.value ?? "").trim();

            if (partInput) {
              partInput.parentElement.innerHTML = partVal || "&nbsp;";
            }
            if (qtyInput) {
              qtyInput.parentElement.innerHTML = qtyVal || "&nbsp;";
            }
          });
        }

        // Remove add/remove row controls in generated quotation output.
        const actionButtons = Array.from(sectionWrapper.querySelectorAll("button"));
        actionButtons.forEach((btn) => btn.remove());
      });

      return doc.body.innerHTML;
    } catch (e) {
      console.warn("Failed to normalize hardware details table:", e);
      return htmlContent;
    }
  }, []);

  const normalizeImageSourcesForGeneratedQuote = useCallback((htmlContent) => {
    if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const backendUrl = String(configApi?.backendUrl || "").trim();
      const backendOrigin = backendUrl.replace(/\/api\/?$/i, "").replace(/\/$/, "");

      const imgNodes = Array.from(doc.querySelectorAll("img[src]"));
      imgNodes.forEach((img) => {
        const rawSrc = String(img.getAttribute("src") || "").trim();
        if (!rawSrc) return;
        const isAbsolute =
          /^https?:\/\//i.test(rawSrc) ||
          /^data:/i.test(rawSrc) ||
          /^blob:/i.test(rawSrc);
        if (!isAbsolute) {
          const normalizedPath = rawSrc.replace(/^\.?\//, "");
          const absoluteSrc = backendOrigin
            ? `${backendOrigin}/${normalizedPath}`
            : normalizedPath;
          img.setAttribute("src", absoluteSrc);
        }

        const className = String(img.getAttribute("class") || "");
        const altText = String(img.getAttribute("alt") || "").trim().toLowerCase();
        const isUploadedInlineImage =
          className.split(/\s+/).includes("psk-uploaded-inline-image") ||
          altText === "uploaded image";
        if (isUploadedInlineImage) {
          const existingStyle = String(img.getAttribute("style") || "").trim();
          const centerStyle = "display:block;margin:12px auto;float:none;";
          img.setAttribute(
            "style",
            existingStyle ? `${existingStyle};${centerStyle}` : centerStyle
          );
        }

      });

      return doc.body.innerHTML;
    } catch (e) {
      console.warn("Failed to normalize image sources:", e);
      return htmlContent;
    }
  }, []);
  // const loadlatedQuote = () => {
  //   const filteredQuotations = quotations.filter((q) => q.leadid === leadid);
  //   setFiles(filteredQuotations[0]?.generateddatafilepath);
  //   setsendid(filteredQuotations[0]?.leadid);
  //   setdownloadid(filteredQuotations[0]?._id);
  //   seteditContent(filteredQuotations[0]?.templatedata);
  //   setTemplateid(filteredQuotations[0]?.templateid);
  // };
  // const handleGenerate = async () => {
  //   if (!Templateid) {
  //     enqueueSnackbar("Please select template first", {
  //       variant: "error",
  //     });
  //     return;
  //   }

  //   // Clean the content before sending
  //   const cleanedContent = cleanNumericValues(content);

  //   const tempId = Templateid
  //   const data = {
  //     type: "GeneratedQuote",
  //     leadid: leadid,
  //     templateid: Templateid,
  //     templatedata: cleanedContent, 
  //     jsondata: JSON.stringify(replacedData),
  //   };
  //   console.log("handleGenerate data quote", data);

  //   SetisLoading(true);
  //   try {
  //     await dispatch(createQuotation(data)).unwrap();
  //     enqueueSnackbar("Quotation Created Successfully", {
  //       variant: "success",
  //       style: { zIndex: 10000 },
  //     });
  //   } catch (error) {
  //     console.error("Failed to create quotation template:", error);
  //     const errorMessage =
  //       error?.error ||
  //       error?.message ||
  //       "Something went wrong. Please try again.";
  //     enqueueSnackbar(errorMessage, {
  //       variant: "error",
  //       style: { zIndex: 10000 },
  //     });
  //   } finally {
  //     SetisLoading(false);
  //     dispatch(fetchAllQuotations());
  //     dispatch(fetchAllQuotationTemplates());
  //     setFiles();
  //     setTemplateid(tempId)
  //     setIsEdit(false)
  //   }
  // };
  const handleGenerate = async (contentOverride) => {
    if (!Templateid) {
      enqueueSnackbar("Please select template first", {
        variant: "error",
      });
      return;
    }

    const isCRM = profiles?.[0]?.subscriptionpackage === "CRM";

    // Ensure summary block is current before generating.
    // IMPORTANT: For CRM, the user edits the summary table inputs.
    // Do NOT overwrite the user's edited values with fresh `summaryTableHtml` during Generate.
    const hasOverride = typeof contentOverride === "string" && contentOverride.length > 0;
    let finalContent = hasOverride ? contentOverride : content;
    if (!isCRM && finalContent && summaryTableHtml) {
      if (finalContent.includes("<!-- SUMMARY_TABLES_BEGIN -->")) {
        finalContent = finalContent.replace(
          /<!-- SUMMARY_TABLES_BEGIN -->[\s\S]*?<!-- SUMMARY_TABLES_END -->/g,
          summaryTableHtml
        );
      } else if (finalContent.includes("<!-- SUMMARY_TABLES -->")) {
        finalContent = finalContent.replace(/<!-- SUMMARY_TABLES -->/g, summaryTableHtml);
      }
    }

    // CRM: Jodit may not update the React state HTML with <input> values.
    // To ensure backend receives typed prices, patch the HTML using current DOM input values.
    // In Preview mode, editor refs/DOM are not available. Use the provided HTML override as source of truth
    // and skip all direct editor reads (prevents ".value of undefined" crashes).
    if (isCRM && !hasOverride) {
      try {
        const editorInstance = editor.current?.editor || editor.current;

        // Prefer latest live editor HTML so newly inserted images are included.
        const liveEditorHtml =
          (typeof editorInstance?.value === "string" && editorInstance.value) ||
          (typeof editorInstance?.getEditorValue === "function" && editorInstance.getEditorValue()) ||
          "";
        if (liveEditorHtml) {
          finalContent = liveEditorHtml;
        }

        // Jodit commonly renders inside an iframe; try to locate its document first.
        let editorDoc = null;
        const iframeCandidates = [];
        if (editorInstance?.iframe) iframeCandidates.push(editorInstance.iframe);

        const rootEl =
          editorInstance?.container ||
          editorInstance?.element ||
          editorInstance?.el ||
          editor.current;
        if (rootEl?.querySelectorAll) {
          iframeCandidates.push(...Array.from(rootEl.querySelectorAll("iframe")));
        }

        for (const iframeEl of iframeCandidates) {
          const d =
            iframeEl?.contentDocument ||
            iframeEl?.contentWindow?.document ||
            null;
          if (d && d.querySelectorAll) {
            editorDoc = d;
            break;
          }
        }

        if (!editorDoc) {
          editorDoc =
            editorInstance?.ownerDocument ||
            editor.current?.ownerDocument ||
            document;
        }

        const priceInputs = editorDoc?.querySelectorAll
          ? editorDoc.querySelectorAll(
            'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
          )
          : [];

        if (priceInputs && priceInputs.length > 0) {
          priceInputs.forEach((inputEl) => {
            const nameAttr = inputEl.getAttribute("name") || "";
            if (!nameAttr) return;

            const safeName = nameAttr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

            const rawVal = inputEl.value ?? "";
            const escapedVal = String(rawVal)
              .replace(/&/g, "&amp;")
              .replace(/"/g, "&quot;");

            // Update only the value="..." attribute for robustness.
            const valueAttrRegex = new RegExp(
              `(<input[^>]*name="${safeName}"[^>]*value=")[^"]*(")`,
              "g"
            );
            const before = finalContent;
            finalContent = finalContent.replace(valueAttrRegex, (m, p1, p2) => `${p1}${escapedVal}${p2}`);

            // Fallback: replace entire input tag if value attr not found.
            if (finalContent === before) {
              const outer = inputEl.outerHTML;
              const inputTagRegex = new RegExp(`<input[^>]*name="${safeName}"[^>]*>`, "g");
              finalContent = finalContent.replace(inputTagRegex, outer);
            }
          });
        }
      } catch (e) {
        console.warn("Failed to patch CRM service prices:", e);
      }
    }

    // Convert Hardware Details inputs to plain text and remove +/- controls before saving generated quote.
    if (isCRM) {
      finalContent = normalizeHardwareDetailsForGeneratedQuote(finalContent);
    }
    finalContent = normalizeImageSourcesForGeneratedQuote(finalContent);

    // Clean the content before sending
    const cleanedContent = cleanNumericValues(finalContent);

    const tempId = Templateid;
    const data = {
      type: "GeneratedQuote",
      leadid: leadid,
      templateid: Templateid,
      templatedata: cleanedContent,
      jsondata: JSON.stringify(replacedData),
    };

    console.log("Generate Payload:", {
      quotationId: selectedlead?.quotationId ?? selectedLead?.quotationId,
      leadId: leadid,
      templateId: Templateid,
      contentLength: (cleanedContent || "").length,
    });
    console.log("handleGenerate data quote", data);

    SetisLoading(true);
    let successMessage = "";
    let errorMessage = "";
    try {
      await dispatch(createQuotation(data)).unwrap();

      successMessage = "Quotation Created Successfully";

      await dispatch(fetchAllQuotations());

    } catch (error) {
      console.error("Failed to create quotation template:", error);
      errorMessage =
        (typeof error === "string" ? error : null) ||
        error?.message ||
        error?.error ||
        "Something went wrong. Please try again.";
    } finally {
      SetisLoading(false);
      setTemplateid(tempId);
      setIsEdit(false);
      // Show snackbar after loader overlay is removed (prevents z-index hiding).
      if (successMessage) {
        setShowVersionHistoryHint(true);
        enqueueSnackbar(successMessage, {
          variant: "success",
          style: { zIndex: 10000 },
        });
      }
      if (errorMessage) {
        enqueueSnackbar(errorMessage, {
          variant: "error",
          style: { zIndex: 10000 },
        });
      }
      // loadlatedQuote()
    }
  };
  const handleedit = () => {
    setsendid(null);
    setContent(editcontent);
    setEditedTemplate(editcontent || "");
    setIsEdit(true);
    setShowEditPreview(false);
  };

  // Save after edit: show preview window (do NOT generate yet)
  const handleSaveEdit = () => {
    // Snapshot the latest editor HTML so Preview/Generate use the edited content,
    // even if other effects update `content` later.
    setEditedTemplate(content || "");
    setShowEditPreview(true);
  };

  // Generate from edit preview: create new quotation version with edited content
  const handleGenerateFromPreview = async () => {
    // Preview mode must never depend on editor refs/DOM; use state snapshot only.
    const snapshot = editedTemplate || "";
    if (!snapshot) {
      console.error("No content available for generation");
      enqueueSnackbar("No edited content to generate. Please edit and Save first.", {
        variant: "error",
        style: { zIndex: 10000 },
      });
      return;
    }

    const payload = {
      quotationId: selectedlead?.quotationId ?? selectedLead?.quotationId,
      leadId: leadid,
      templateId: Templateid,
      content: snapshot,
    };
    console.log("Generate Payload:", payload);

    await handleGenerate(snapshot);
    setShowEditPreview(false);
    setIsEdit(false);
  };
  // Handle download quotation
  const handleDownload = async () => {
    if (!downloadid) {
      enqueueSnackbar("Please select template before download", {
        variant: "error",
        style: { zIndex: 10000 },
      });
      return;
    }

    SetisLoading(true);
    try {
      const response = await dispatch(downloadQuotationFile(downloadid));
      const resData = response?.payload;
      console.log("resDataresData", resData);
      if (!resData?.downloadUrl) {
        throw new Error("Download failed");
      }

      const link = document.createElement("a");
      link.href = resData.downloadUrl;

      const extension = resData.contentType?.includes("pdf") ? "pdf" : "file";

      link.setAttribute("download", `quotation.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      enqueueSnackbar("Quotation File Successfully Downloaded", {
        variant: "success",
        style: { zIndex: 10000 },
      });
    } catch (error) {
      enqueueSnackbar(
        error?.message || "Something went wrong. Please try again.",
        {
          variant: "error",
          style: { zIndex: 10000 },
        }
      );
    } finally {
      SetisLoading(false);
      setdownloadid(null);
    }
  };

  // Handle send quotation - UPDATE FOR JODIT
  const handleSend = async () => {
    if (!sendid) {
      enqueueSnackbar("Please select template first", {
        variant: "error",
      });
      return;
    }
    SetisLoading(true);
    try {
      await dispatch(
        sendQuotationToClient({
          quotationId: setMailQuotation?._id,
        })
        // sendQuotationToClient({
        //   leadid: sendid,
        //   templatedata: content,
        // })
      );
      enqueueSnackbar("The quotation file has been sent successfully", {
        variant: "success",
        style: { zIndex: 10000 },
      });
    } catch (error) {
      console.error("Failed to create quotation template:", error);
      const errorMessage =
        (typeof error === "string" ? error : null) ||
        error?.message ||
        error?.error ||
        "Something went wrong. Please try again.";
      enqueueSnackbar(errorMessage, {
        variant: "error",
        style: { zIndex: 10000 },
      });
    } finally {
      SetisLoading(false);
      setContent(""); // Use setContent instead of setValue
    }
  };

  // ... (keep all your existing data transformation functions as they are)
  // getDescriptionValues, getTotalDescriptionValue, getHardwareValues, etc.

  const getDescriptionValues = useCallback(
    (projectID, personID, typeService) => {
      if (!tasks) return [];
      return tasks.filter(
        (desc) => desc.projectid === projectID && desc.taskownerid === personID
      );
    },
    [tasks]
  );

  const getTotalDescriptionValue = useCallback(
    (projectID, personID, typeService) => {
      const descriptions = getDescriptionValues(
        projectID,
        personID,
        typeService
      );

      let totalValue = descriptions.reduce(
        (sum, desc) => sum + (desc.value || 0),
        0
      );

      // Check if this is an Installation service
      if (typeService && typeService.toLowerCase().includes("installation")) {
        // Find the maximum trip duration for this person (to avoid duplicate counting)
        let maxTripDuration = 0;
        const uniqueTripDurations = new Set();

        descriptions.forEach((desc) => {
          if (desc.tripduration) {
            uniqueTripDurations.add(desc.tripduration);
            maxTripDuration = Math.max(maxTripDuration, desc.tripduration);
          }
        });

        if (maxTripDuration > 0) {
          // Add: (tripduration * perdiem) + (tripduration * averageCost)
          totalValue +=
            maxTripDuration * perdiem + maxTripDuration * averagecost;
        }
      }

      return totalValue;
    },
    [getDescriptionValues, perdiem, averagecost]
  );

  const getHardwareValues = useCallback(
    (projectID, typeService) => {
      if (!items) return [];
      return items.filter(
        (desc) =>
          desc.projectid === projectID &&
          // desc.taskownerid === personID &&
          desc.typeservice === typeService
      );
    },
    [items]
  );


  const getTotalHardwareCostValue = useCallback(
    (projectID, personID, typeService) => {
      let hardwareValue = 0;
      const hardwareCost = getHardwareValues(projectID, typeService);
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      hardwareCost.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
      return hardwareValue;
      // return hardwareCost.reduce((sum, desc) => sum + (desc.totalprice || 0), 0);
    },
    [getHardwareValues]
  );

  const transformFilteredQuotation = useCallback(
    (filteredQuotation, employees) => {
      const result = [];

      Object.entries(filteredQuotation || {}).forEach(
        ([projectName, typeServices]) => {
          Object.entries(typeServices).forEach(([typeService, items]) => {
            items.forEach((item) => {
              if (!item?.WorkEntries?.length) return;

              // Group work entries by person
              const groupedByPerson = {};
              const personRoleMap = {};

              item.WorkEntries.forEach((entry) => {
                const personName = entry?.createdBy?.name;
                const personRoles = entry?.createdBy?.role || [];
                const personId = entry?.taskownerid;

                if (!groupedByPerson[personName]) {
                  groupedByPerson[personName] = { totalHours: 0, personId };
                }
                groupedByPerson[personName].totalHours +=
                  entry.hoursassigned || 0;

                if (!personRoleMap[personName]) {
                  personRoleMap[personName] = { roles: personRoles, personId };
                }
              });

              console.log("personRoleMap", personRoleMap);
              console.log("item quotationDetails", item.quotationDetails);

              // Convert grouped persons into array with costs
              Object.entries(groupedByPerson).forEach(([name, personData]) => {
                const totalHours = personData.totalHours;
                const personId = personData.personId;
                const ProjectID = item?.ProjectID;
                const ProjectNotes = item?.ProjectNotes;
                const ServiceQuotedValue = item?.QuotedValue;
                const servicewiseMargin = item?.ProjectMargin;

                // Get roles for this person
                const personRoleInfo = personRoleMap[name];
                const personRoles = personRoleInfo?.roles || [];

                console.log("Person Name:", name);
                console.log("Person Roles:", personRoles);

                // Find matching quotation based on roles
                let matchedQuotation = null;

                if (item.quotationDetails) {
                  // Try to match by checking if any role matches the designation
                  // Since personRoles is an array and designation is a string, we need to check each role
                  for (const role of personRoles) {
                    matchedQuotation = item.quotationDetails.find(
                      (q) => q.designation.toLowerCase() === role.toLowerCase()
                    );

                    if (matchedQuotation) {
                      console.log(
                        `Matched role "${role}" with designation "${matchedQuotation.designation}"`
                      );
                      break;
                    }
                  }

                  // If no match found with exact role, try partial matching
                  if (!matchedQuotation) {
                    for (const role of personRoles) {
                      matchedQuotation = item.quotationDetails.find(
                        (q) =>
                          q.designation
                            .toLowerCase()
                            .includes(role.toLowerCase()) ||
                          role
                            .toLowerCase()
                            .includes(q.designation.toLowerCase())
                      );

                      if (matchedQuotation) {
                        console.log(
                          `Partially matched role "${role}" with designation "${matchedQuotation.designation}"`
                        );
                        break;
                      }
                    }
                  }
                }

                console.log("Matched Quotation:", matchedQuotation);

                const currentEmployee = employees.find((emp) => {
                  const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`
                    .trim()
                    .toLowerCase();
                  return fullName === name.trim().toLowerCase();
                });

                const capitalizedRoles =
                  currentEmployee?.customRoles?.map(
                    (role) =>
                      role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
                  ) || [];

                // Use matched quotation hourly rate, fallback to 0 if not found
                const hourlyRate = matchedQuotation
                  ? (matchedQuotation?.hourlysalaray || 0) +
                  (matchedQuotation?.overheadpercentage || 0)
                  : 0;

                const totalCost = totalHours * hourlyRate;

                // External helpers
                const descriptionTotal = getTotalDescriptionValue(
                  item.ProjectID,
                  personId,
                  item.TypeService
                );

                const hardwareTotal = getTotalHardwareCostValue(
                  item.ProjectID,
                  personId,
                  item.TypeService
                );

                const hasProjectManagerRole =
                  capitalizedRoles.includes("Project manager");
                result.push({
                  servicewiseMargin,
                  ServiceQuotedValue,
                  projectName,
                  typeService: item.TypeService,
                  resourceType: item.ResourceType,
                  personId,
                  ProjectID,
                  ProjectNotes,
                  personName: name,
                  roles: capitalizedRoles,
                  totalHours,
                  hourlyRate,
                  totalCost,
                  descriptionTotal,
                  hardwareTotal,
                  grandTotal: item?.TypeService?.toLowerCase().includes(
                    "hardware"
                  )
                    ? (hasProjectManagerRole ? hardwareTotal : 0) +
                    descriptionTotal
                    : descriptionTotal + totalCost,
                  matchedDesignation:
                    matchedQuotation?.designation || "Not matched",
                });
              });
            });
          });
        }
      );

      return result;
    },
    [getTotalDescriptionValue, getTotalHardwareCostValue]
  );

  const groupByTypeService = (processedData) => {
    return processedData.reduce((acc, curr) => {
      if (!acc[curr.typeService]) {
        acc[curr.typeService] = [];
      }
      acc[curr.typeService].push(curr);
      return acc;
    }, {});
  };

  const processedData = useMemo(() => {
    return transformFilteredQuotation(filteredQuotation, employees);
  }, [filteredQuotation, employees, transformFilteredQuotation]);

  const groupedData = useMemo(() => {
    return groupByTypeService(processedData);
  }, [processedData]);

  // Build Summary table HTML: CRM = Finance Summary (Project Name, Quoted Price); non-CRM = Services + Required Hardware
  // Source: tableServiceTotalsProp (from P&L table) or fallback: compute from groupedData (must run after groupedData is defined)
  // For CRM package: when template has {{Summary Tables}}, show Finance Summary in pre-quotation and pass in templatedata on Generate
  useEffect(() => {
    const cellStyle =
      "border: 1px solid #000; padding: 8px; min-width: 80px; min-height: 32px;";
    let tableHtml = "";

    const isCRM = profiles?.[0]?.subscriptionpackage === "CRM";

    // CRM package: Finance Summary (Project Name, Quoted Price) when template has {{Summary Tables}} — show as in P&L pre-quotation
    if (isCRM && selectedlead) {
      const serviceTypesArrCandidate =
        selectedlead?.servicetypes ??
        selectedlead?.serviceTypes ??
        selectedlead?.ServiceTypes ??
        selectedlead?.TypeService ??
        [];

      // Normalize service types from multiple possible lead shapes.
      // Your lead payload sometimes comes as:
      //   { TypeService: ["Software", "Cloud", ...] }
      // or:
      //   { servicetypes: { TypeService: [...] } }
      // or:
      //   { servicetypes: ["Software", ...] }
      const serviceTypes = (() => {
        const toTypeName = (st) => {
          if (!st) return "";
          if (typeof st === "string") return st;
          return (
            st.TypeService ||
            st.typeService ||
            st.ServiceType ||
            st.serviceType ||
            st.type ||
            ""
          );
        };

        if (Array.isArray(serviceTypesArrCandidate)) {
          return serviceTypesArrCandidate.map(toTypeName).filter(Boolean);
        }

        if (
          serviceTypesArrCandidate &&
          Array.isArray(serviceTypesArrCandidate.TypeService)
        ) {
          return serviceTypesArrCandidate.TypeService.map(toTypeName).filter(Boolean);
        }

        if (
          serviceTypesArrCandidate &&
          Array.isArray(serviceTypesArrCandidate.serviceTypes)
        ) {
          return serviceTypesArrCandidate.serviceTypes.map(toTypeName).filter(Boolean);
        }

        return [];
      })();

      const quotedTotal =
        selectedlead?.quotedprice ??
        selectedlead?.quotedPrice ??
        selectedlead?.QuotedPrice ??
        selectedlead?.QuotedValue ??
        0;

      const safeTotal = Number(quotedTotal) || 0;

      // Price commas + value sync: delegated handlers on Jodit editor (formatServicePriceElement) — avoids stripped inline oninput and full-edit glitches.

      // Build short editable table:
      // 1) Service types column (from lead.servicetypes[*].TypeService)
      // 2) Price input per service type
      const priceHeader = currency ? `Price (${currency})` : "Price";
      const hasHardwareService = serviceTypes.some(
        (st) => String(st || "").trim().toLowerCase() === "hardware"
      );
      const safeServiceTypes = serviceTypes.map((serviceType) =>
        String(serviceType).replace(/</g, "&lt;")
      );

      tableHtml = `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Finance Summary</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Service types</th><th style="${cellStyle} text-align: right;">${priceHeader}</th></tr></thead><tbody>${safeServiceTypes
        .map((serviceType, idx) => {
          // Leave input blank so user can enter price per service type.
          // If you later want prefills, hook into existing P&L totals and set value here.
          return `<tr style="background-color: #fff;"><td style="${cellStyle}">${serviceType}</td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="servicePrice_${idx}" value="" /></td></tr>`;
        })
        .join("")}<tr style="background-color: #bfdbfe; font-weight: bold;"><td style="${cellStyle}">Total quoted price</td><td style="${cellStyle} text-align: right;">${USAComma(Number(safeTotal).toFixed(2))}</td></tr></tbody></table></div></div>`;

      if (hasHardwareService) {
        tableHtml += buildCrmHardwareDetailsSectionHtml(cellStyle);
      }
      /* legacy inline onclick removed */
      if (false) {
        tableHtml += `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Hardware Details</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Part name</th><th style="${cellStyle} text-align: right;">Part qty</th></tr></thead><tbody><tr style="background-color: #fff;"><td style="${cellStyle}"><input type="text" style="width: 100%; border: none; outline: none; text-align: left; font-size: 12px;" name="hardwarePartName_0" value="" onkeydown="if(event.key==='Backspace'||event.key==='Delete'){event.stopPropagation();}" oninput="this.setAttribute('value', this.value);" /></td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="hardwarePartQty_0" value="" onkeydown="if(event.key==='Backspace'||event.key==='Delete'){event.stopPropagation();}" oninput="this.value=(this.value||'').toString().replace(/[^0-9]/g,''); this.setAttribute('value', this.value);" /></td></tr></tbody></table><div style="display:flex; justify-content:flex-end; gap:8px; margin-top:8px;"><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rowCount=tbody.querySelectorAll('tr').length; var uid=Date.now()+''+Math.floor(Math.random()*1000); var tr=document.createElement('tr'); tr.style.backgroundColor='#fff'; tr.innerHTML='<td style=&quot;${cellStyle}&quot;><input type=&quot;text&quot; style=&quot;width:100%; border:none; outline:none; text-align:left; font-size:12px;&quot; name=&quot;hardwarePartName_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;if(event.key===\\'Backspace\\'||event.key===\\'Delete\\'){event.stopPropagation();}&quot; oninput=&quot;this.setAttribute(\\'value\\', this.value);&quot; /></td><td style=&quot;${cellStyle} text-align:right;&quot;><input type=&quot;text&quot; inputmode=&quot;numeric&quot; style=&quot;width:100%; border:none; outline:none; text-align:right; font-size:12px;&quot; name=&quot;hardwarePartQty_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;if(event.key===\\'Backspace\\'||event.key===\\'Delete\\'){event.stopPropagation();}&quot; oninput=&quot;this.value=(this.value||\\'\\').toString().replace(/[^0-9]/g,\\'\\'); this.setAttribute(\\'value\\', this.value);&quot; /></td>'; tbody.appendChild(tr);})(this)">+</button><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rows=tbody.querySelectorAll('tr'); if(rows.length<=1) return; tbody.removeChild(rows[rows.length-1]);})(this)">-</button></div></div></div>`;
      }
    }

    if (!isCRM) {
      let totalsByService = {};

      // Prefer tableServiceTotalsProp (already quoted price per service from P&L)
      const hasPropData =
        tableServiceTotalsProp &&
        typeof tableServiceTotalsProp === "object" &&
        Object.keys(tableServiceTotalsProp).filter((k) => k !== "total").length > 0;

      if (hasPropData) {
        Object.entries(tableServiceTotalsProp).forEach(([key, val]) => {
          if (key === "total") return;
          const num = parseFloat(String(val).replace(/[^\d.-]/g, ""));
          if (!isNaN(num) && num > 0) {
            totalsByService[key] = num;
          }
        });
      }

      // Fallback: compute quoted price from groupedData when tableServiceTotalsProp is empty
      if (Object.keys(totalsByService).length === 0 && groupedData && selectedlead) {
        const totalProjectQuotedValue =
          Number(selectedlead?.QuotedValue) || 0;
        Object.entries(groupedData).forEach(([typeService, rows]) => {
          if (!rows || rows.length === 0 || !rows[0]) return;
          const marginPercentage =
            parseFloat(rows[0]?.servicewiseMargin ?? rows[0]?.ProjectMargin ?? 0) || 0;
          const marginForCalc = Number(Number(marginPercentage).toFixed(1));
          const quotedValue = (marginForCalc / 100) * totalProjectQuotedValue;
          if (quotedValue > 0) {
            totalsByService[typeService] = quotedValue;
          }
        });
      }

      // Services table (only when we have totals) - non-CRM
      if (Object.keys(totalsByService).length > 0) {
        const projectQuotedValue =
          selectedlead?.QuotedValue != null && Number(selectedlead.QuotedValue) > 0
            ? Number(selectedlead.QuotedValue)
            : null;
        const sumOfServices = Object.values(totalsByService).reduce((s, n) => s + n, 0);
        const grandTotal =
          projectQuotedValue != null ? projectQuotedValue : sumOfServices;

        const serviceOrder = ["Cloud", "Software", "Installation", "Hardware"];
        let rows = serviceOrder.filter(
          (t) => totalsByService[t] != null && Number(totalsByService[t]) > 0
        );
        if (rows.length === 0) {
          rows = Object.keys(totalsByService).filter((k) => k !== "total");
        }

        tableHtml = `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 500px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center;">Services</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Service Type</th><th style="${cellStyle} text-align: right;">Quoted Price (${currency})</th></tr></thead><tbody>`;
        rows.forEach((serviceType) => {
          const val = totalsByService[serviceType];
          if (val == null) return;
          const displayVal = Number(val);
          tableHtml += `<tr style="background-color: #fff;"><td style="${cellStyle}">${serviceType}</td><td style="${cellStyle} text-align: right;">${USAComma(displayVal.toFixed(2))}</td></tr>`;
        });
        tableHtml += `<tr style="background-color: #bfdbfe; font-weight: bold;"><td style="${cellStyle}">Total</td><td style="${cellStyle} text-align: right;">${USAComma(Number(grandTotal).toFixed(2))}</td></tr></tbody></table></div></div>`;
      }
    }

    // Required Hardware table: unique parts, highest quantity per part (for selected project)
    // filteredQuotation may be keyed by quotationId or ProjectName - collect all ProjectIDs from it
    if (filteredQuotation && items?.length) {
      const projectIds = new Set();
      Object.values(filteredQuotation || {}).forEach((typeServices) => {
        Object.values(typeServices || {}).forEach((serviceItems) => {
          (serviceItems || []).forEach((it) => {
            if (it?.ProjectID != null) projectIds.add(String(it.ProjectID));
          });
        });
      });
      // Also add selected project's _id if available (lead/project id)
      const selectedProjectId = selectedlead?._id ?? selectedlead?.quotationId;
      if (selectedProjectId != null) projectIds.add(String(selectedProjectId));

      const hardwareItems = items.filter((i) => {
        const pid = i.projectid ?? i.projectId;
        if (pid == null || String(i.typeservice || "").toLowerCase() !== "hardware") return false;
        const pidStr = String(pid);
        return projectIds.has(pidStr);
      });

      // Unique part: normalize name (trim), take highest quantity per part
      const partToMaxQty = {};
      hardwareItems.forEach((h) => {
        const part = (h.assemblepartdescription || "—").trim() || "—";
        const qty = Math.max(0, Number(h.quantity) || 0);
        partToMaxQty[part] = Math.max(partToMaxQty[part] ?? 0, qty);
      });
      const requiredHardwareRows = Object.entries(partToMaxQty)
        .filter(([, qty]) => qty > 0)
        .sort((a, b) => String(a[0]).localeCompare(String(b[0])));

      if (requiredHardwareRows.length > 0) {
        tableHtml += `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 500px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center;">Required Hardware</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Part</th><th style="${cellStyle} text-align: right;">Quantity</th></tr></thead><tbody>`;
        requiredHardwareRows.forEach(([part, qty]) => {
          tableHtml += `<tr style="background-color: #fff;"><td style="${cellStyle}">${String(part).replace(/</g, "&lt;")}</td><td style="${cellStyle} text-align: right;">${qty}</td></tr>`;
        });
        tableHtml += `</tbody></table></div></div>`;
      }
    }

    setSummaryTableHtml(tableHtml);
  }, [
    profiles,
    tableServiceTotalsProp,
    groupedData,
    selectedlead,
    currency,
    USAComma,
    filteredQuotation,
    items,
  ]);

  console.log("groupgrgerhgredData", groupedData);

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <div>
        <div className="fixed w-full inset-0 bg-black/50 flex items-center justify-center z-[1300]">
          <div className="min-w-[60%] max-h-[98%] max-w-[70%] bg-white shadow-lg rounded-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg font-bold">Quotation</h2>

              <button
                onClick={() => {
                  setIsEdit(false);
                  setShowEditPreview(false);
                  setShowQuoteModal(false);
                }}
                className="text-gray-500 hover:text-black"
              >
                <CloseIcon className=" cursor-pointer  bg-white" />
              </button>
            </div>
            <div className="w-full flex justify-between">
              <div className="flex gap-2">
                <div
                  className="relative flex flex-col gap-1 justify-center align-middle items-start"
                  ref={groupdownRef}
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700"
                  >
                    Template
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsTemplateOpen(!isTemplateOpen);
                    }}
                    className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                  >
                    <span
                      onClick={() => setAssignedGroup()}
                      className="truncate min-w-0 flex-1 text-left"
                    >
                      {selectedTemplate ? selectedTemplate : "All"}
                    </span>
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isTemplateOpen && (
                    <div className="absolute left-0 top-full p-1 w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      {/* <div
                      className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                        }`}
                      onClick={() => {
                        setIsTemplateOpen(false);
                      }}
                    >
                      <label>All</label>
                    </div> */}

                      {template.map((temp) => (
                        <div
                          key={temp.id}
                          className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer `}
                          onClick={() => {
                            setIsTemplateOpen(false);
                            loadTemplate(temp.templatedataUrl);
                            setselectedTemplate(temp.templatename);
                            setTemplateid(temp._id);
                            setsendid("");
                            setFiles();
                          }}
                        >
                          <label>{temp.templatename}</label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  ref={versionRef}
                  className="relative flex flex-col gap-1 justify-center align-middle items-center"
                >
                  <label
                    htmlFor="selectedStatus"
                    className="block text-sm font-semibold text-gray-700"
                  >
                    Version History
                  </label>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowVersionHistoryHint(false);
                      setisHistoryOpen(!isHistoryOpen);
                    }}
                    className={`w-24 relative outline-none date-picker-placeholder flex justify-start rounded-md p-2 pr-7 text-xs transition-all duration-300 ${showVersionHistoryHint
                      ? "border border-emerald-500 shadow-[0_0_0_3px_rgba(16,185,129,0.18)] animate-pulse"
                      : "border border-[#e0e7ff]"
                      }`}
                  >
                    <span
                      // onClick={() => setAssignedGroup()}
                      className="truncate min-w-0 flex-1 text-left"
                    >
                      All
                    </span>
                    {showVersionHistoryHint && (
                      <span className="pointer-events-none absolute right-8 top-1/2 z-10 flex h-2.5 w-2.5 -translate-y-1/2">
                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
                        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
                      </span>
                    )}
                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                  </button>
                  {isHistoryOpen && (
                    <div className="absolute left-0 top-full text-xs border p-1 max-h-60 overflow-auto text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                      {quotation && quotation.length > 0 ? (
                        quotation
                          .sort(
                            (a, b) =>
                              new Date(a.createdAt) - new Date(b.createdAt)
                          )
                          .map((quot, index) => (
                            <div
                              key={quot._id}
                              className="flex justify-between align-middle items-center p-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => {
                                setIsTemplateOpen(false);
                                setIsEdit(false);
                                setShowEditPreview(false);
                                if (quot.type === "GeneratedQuote") {
                                  setFiles(quot.generateddatafilepath);
                                  setsendid(quot.leadid);
                                  setdownloadid(quot._id);
                                  seteditContent(quot.templatedata);
                                  setTemplateid(quot.templateid);
                                  setsetMailQuotation(quot)
                                } else {
                                  setFiles();
                                  setProcessedTemplateHtml("");
                                  setContent(quot.templatedata);
                                  setsendid(null);
                                  setsetMailQuotation(quot)
                                }
                                setisHistoryOpen(!isHistoryOpen);
                                setselectedTemplate("");
                              }}
                            >
                              <div className="flex items-center">
                                <span>{quot.quotationId ?? quot.QuotationId ?? quot.quotationNumber ?? quot.leadid ?? "—"}</span>
                                <span>_v{index + 1}</span>
                              </div>
                            </div>
                          ))
                      ) : (
                        <div className="p-2 text-center text-gray-500">
                          No quotation
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex gap-2 justify-end align-bottom items-end">
                {showEditPreview ? (
                  <>
                    <button
                      onClick={() => setShowEditPreview(false)}
                      className="p-1.5 text-sm rounded-md bg-gray-500 text-white inline-block"
                    >
                      Back to Edit
                    </button>
                    {canCreateQuotation && (
                    <button
                      onClick={handleGenerateFromPreview}
                      className="p-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                    >
                      Generate
                    </button>
                    )}
                  </>
                ) : (
                  <>
                    {canCreateQuotation && (
                    <button
                      onClick={IsEdit ? handleSaveEdit : handleGenerate}
                      className="p-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                    >
                      {IsEdit ? "Save" : "Generate"}
                    </button>
                    )}
                    {files && !IsEdit && canCreateQuotation && (
                      <button
                        onClick={handleedit}
                        className="px-3.5 py-1.5 text-sm rounded-md bg-[#e32278] text-white inline-block"
                      >
                        Edit
                      </button>
                    )}
                    {canDownloadQuotation && (
                    <button
                      disabled={!files}
                      onClick={() => handleDownload()}
                      className={`${!files
                        ? "cursor-not-allowed bg-gray-400"
                        : "cursor-pointer bg-[#e32278]"
                        } p-1.5 text-sm rounded-md text-white inline-block`}
                    >
                      Download
                    </button>
                    )}
                    {canSendQuotation && (
                    <button
                      disabled={!files}
                      onClick={handleSend}
                      className={`${!files
                        ? "cursor-not-allowed bg-gray-400"
                        : "cursor-pointer bg-[#e32278]"
                        } p-1.5 text-sm rounded-md text-white inline-block`}
                    >
                      Send Email
                    </button>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="w-full min-h-[5rem] max-h-[24rem] overflow-y-scroll p-2 border mt-2">
              <input
                ref={imageUploadInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageFileSelected}
                style={{ display: "none" }}
              />
              {showEditPreview ? (
                <div className="preview w-full p-4 bg-white">
                  <div className="text-sm font-semibold text-gray-600 mb-2">Quotation Preview (Edited)</div>
                  <div
                    className="border rounded p-4 min-h-[20rem] bg-white"
                    dangerouslySetInnerHTML={{ __html: editedTemplate || content || "" }}
                  />
                </div>
              ) : sendid ? (
                <FileViewer files={files} />
              ) : (
                <div className="preview w-full shadow-[inset_0_0_10px_rgba(0,0,0,0.3)]">
                  {content ? (
                    <div className="flex h-[20rem]">
                      <div className="w-full">
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={config}
                          onChange={handleEditorChangeWithDebounce}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>No Template</div>
                  )}

                  {content &&
                    (showfile?.[0]?.message ===
                      "No files available for the given Lead ID" ||
                      showfile?.files?.length === 0 ? (
                      <div>No Attachament</div>
                    ) : (
                      <FilesViewer showfile={showfile} />
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Quotation;
